import './src/styles/global.css'
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false;

// 古い Service Worker の影響で ChunkLoadError (404) が発生した場合の自動キャッシュクリア・即時リロード処理
const purgeServiceWorkerAndReload = () => {
  if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
      if (window.caches) {
        caches.keys().then((keys) => {
          keys.forEach((key) => caches.delete(key));
        });
      }
      window.location.reload();
    });
  } else if (typeof window !== "undefined") {
    window.location.reload();
  }
};

export const onServiceWorkerUpdateReady = () => {
  purgeServiceWorkerAndReload();
};

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    // 1. 同期エラーの捕捉
    window.addEventListener("error", (e) => {
      if (e?.message && /Loading chunk .* failed/i.test(e.message)) {
        purgeServiceWorkerAndReload();
      }
    });

    // 2. 非同期 Promise Rejection (Webpack 5 の ChunkLoadError) の捕捉
    window.addEventListener("unhandledrejection", (e) => {
      const msg = e?.reason?.message || (typeof e?.reason === "string" ? e.reason : "");
      if (e?.reason?.name === "ChunkLoadError" || /Loading chunk .* failed/i.test(msg)) {
        purgeServiceWorkerAndReload();
      }
    });
  }
};